"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TimeFormats = require("./TimeFormats");
Object.keys(_TimeFormats).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TimeFormats[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TimeFormats[key];
    }
  });
});